export const PARTNERSHIP = "Partnership";

export const KEYMAN = "Keyman";

export const INDIVIDUAL =  "Individual (& Family)";

export const EMPLOYER_EMPLOYEE_SCHEME_A = "Employer Employee Scheme A";

export const EMPLOYER_EMPLOYEE_SCHEME_B = "Employer Employee Scheme B";

export const HUF = "HUF";

export const MWP_ACT =  "MWP ACT";